<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'
import formatDate, { formatDateRange } from '@utils/format-date'
import { defaultStatusFilter } from '@utils/filter-value-to-text'

import { PortalTarget } from 'portal-vue'
import { authComputed } from '@state/helpers'

export default {
  page: {
    title: '查看會員等級方案',
    meta: [{ name: 'description', content: 'View MemberLevel' }],
  },
  filters: {
    formatDate,
    formatDateRange,
    defaultStatusFilter,
  },
  components: {
    Layout,
    PortalTarget,
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    OrderForm: () => import('@components/PrepaidOrderForm'),
    PrepaidOrderForm: () => import('@components/Orders/PrepaidOrderForm'),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeTabIndex: 0,
      displayValue: Object.assign({}, this.defaultValue),
      sideTabList: [
        {
          icon: 'edit',
          title: '編輯等級方案',
          name: 'edit',
          component: () => import('./MemberLevelItemDetailEdit'),
        },
      ],
    }
  },
  watch: {
    
  },
  created() {
  },
  provide() {
    return {
      dbData: this.defaultValue
    };
  },
  mounted() {
  },
  computed: {
    ...authComputed,
    activeTab() {
      return this.sideTabList[this.activeTabIndex]
    },
    // isOrderManager() {
    //   return !this.currentUserRoutes.includes('add-prepaid') && this.currentUserRoutes.includes('prepaid')
    // },
    pagination() {
      return this.$route.params.pagination
    },
    filterData() {
      return this.$route.params.filterData
    },
    // showDrawer:{
    //   get(){
    //     return this.$route.params.drawer;
    //   },
    //   set(value){
    //     this.drawerVisible=value
    //   }

    // }
  },
  methods: {
    backToList() {
      this.$router.push({
        name: 'member',
        params: {
          activeTab: '1',
          pagination: this.pagination,
          filterData: this.filterData,
        },
      })
    },
    // handleUpdateOrders() {
    //   if (!this.isOrderManager)
    //     this.activeTabIndex = 1

    //   this.$nextTick(()=>{
    //     let timeout = setInterval(()=>{
    //       if(this.$refs.orders !== undefined){
    //         clearInterval(timeout)
    //         this.$refs.orders.tryToFetchOrder()
    //       }
    //     }, 500)
    //   })

    //   this.handleCloseDrawer()
    // },
    // handleCloseDrawer() {
    //   this.$refs.drawer.closeDrawer()
    // },
  },
}
</script>

<template>
  <Layout>
    <!-- <div v-if="delay" v-loading="delay" style="height:100vh"></div> -->
    <template>
      <div :class="$style.wrapper">
        <div :class="$style.sidebar">
          <div :class="$style.header">
            <el-button class="is-round isStyleBase mb-4" @click="backToList">
              <BaseIcon name="arrow-left" />
              返回
            </el-button>
            <h3>{{ displayValue.title }}</h3>
            <ul :class="$style.metadata">
              <li class="Jost text"> 創建時間： {{ displayValue.createdAt | formatDate('dateTime') }}</li>
              <li class="Jost text">
                最後編輯時間：
                {{ displayValue.updatedAt | formatDate('dateTime') }}
              </li>
            </ul>
          </div>
          <div>
            <el-radio-group v-model="activeTabIndex" class="is-block" :class="$style.tabs">
              <el-radio-button v-for="(tab, $index) in sideTabList" :key="tab.name" :label="$index">
                <BaseIcon :name="tab.icon" class="fs-xl align-text-top" />
                <span>{{ tab.title }}</span>
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div :class="$style.content">
          <keep-alive>
            <component :is="activeTab.component" :ref="activeTab.name" :key="activeTab.name" :default-value.sync="displayValue"></component>
          </keep-alive>
        </div>
      </div>
    </template>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_sidebar.scss';
.enabled {
  :global {
    .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
      color: inherit;
      cursor: pointer;
      &:hover {
        color: $color-primary;
      }
    }
  }
}
</style>
